<template>
<highcharts :options="options" />
</template>

<script>
import { mapGetters } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import isNil from 'lodash/isNil';
import { chartColorSet } from '@/constants/chart-options';

import { convertValuByUnit } from '@/utils/number';

const options = {
  chart: {
    type: 'solidgauge',
    height: '200px',
    spacingBottom: -90,
    spacingTop: 0,
    spacingRight: 0,
    spacingLeft: 0,
  },
  title: false,
  credits: false,
  pane: {
    startAngle: -90,
    endAngle: 90,
    background: {
      innerRadius: '60%',
      outerRadius: '100%',
      shape: 'arc', // 원의 모양은 호로 표현
    },
  },
  yAxis: {
    min: 0,
    max: 100,
    lineWidth: 0,
    tickAmount: 2,
    labels: {
      y: 15,
    },
  },
  plotOptions: {
    solidgauge: {
      dataLabels: {
        y: -45,
        borderWidth: 0,
        style: {
          textAlign: 'center',
          fontSize: '20px',
        },
        formatter() {
          return `${this.y}%`;
        },
      },
    },
  },
  tooltip: false,
  series: [],
  colors: chartColorSet,
};

export default {
  name: 'WCacheHitratioChart',
  props: {
    performanceData: Object,
    cacheKey: String,
  },
  data() {
    return {
      options: cloneDeep(options),
    };
  },
  computed: mapGetters(['selectedNode']),
  watch: {
    performanceData: {
      immediate: true,
      handler(data) {
        if (isNil(data)) {
          return;
        }
        // number util을 사용하면 문자열로 return되기 때문에 parseFloat을 이용한다.
        this.options.series = [
          {
            data: [parseFloat(convertValuByUnit(data[this.cacheKey]))],
          },
        ];
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/database/components/chart/CacheHitratioChart.vue